import Vue from "vue";
import VueRouter from "vue-router";
import Inicio from "../views/InicioView.vue";
import auth from "../auth/auth";

Vue.use(VueRouter);

const routes = [
  {
    path: "/ingresar",
    name: "login",
    component: () => import("../views/LoginView.vue"),
    meta: {
      requiresAuth: false
    },
    children: [
      {
        path: "crear-contrasena/:id_cliente",
        name: "crear_contrasena",
        component: () => import("../components/login/RecuperarClave.vue")
      }
    ]
  },
  {
    path: "/inicio",
    name: "ingresa",
    component: Inicio,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/cuenta-capital",
    name: "cuenta-capital",
    component: () => import("../views/productos/CuentaCapitalView.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/creditos",
    name: "creditos",
    component: () => import("../views/productos/CreditosView.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/cuenta/cambiar-clave",
    name: "cuenta",
    component: () => import("../views/CuentaView.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/proximos-pagos",
    name: "proximos-pagos",
    component: () => import("../views/ProximosPagosView.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/mantencion",
    name: "mantencion",
    component: () => import("../views/MantencionView.vue"),
    meta: {
      requiresAuth: true
    }
  },

  {
    path: "/",
    redirect: "/inicio"
  },
  {
    path: "*",
    redirect: "/inicio"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  //Lógica que se ejecuta antes de renderizar la ruta a la vista respectiva
  //Primero se debe validar si la ruta requiere autenticación
  const mantencion = process.env.VUE_APP_MANTENCION;
  if (mantencion == 1) {
    if (to.path === "/mantencion") next();
    else next("/mantencion");
    return;
  } else if (mantencion == 0 && to.path === "/mantencion") {
    next("/");
    return;
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    //Si la ruta requiere autenticación se valida si el usuario está autenticado
    if (auth.isAuthenticated()) {
      //Si el usuario está autenticado se valida si el usuario debe cambiar su clave
      let cambio_clave = auth.getUserLogged().b_cambiar_clave;
      if (cambio_clave) {
        if (to.path === "/cuenta/cambiar-clave") next();
        else next("/cuenta/cambiar-clave");
        return;
      }
      //Si el usuario no debe cambiar su clave se realizan otras validaciones según la ruta a la que desee acceder y sus precondiciones
      else {
        //Si la ruta no tiene que validar condiciones especiales se redirige a la ruta solicitada
        next();
        return;
      }
    }
    //Si el usuario no está autenticado se redirige a la ruta de login
    else {
      next("/ingresar");
    }
  }
  //Si la ruta no requiere autenticación se valida si el usuario está autenticado para redirigirlo a la ruta de inicio
  else {
    if (auth.isAuthenticated()) {
      next("/ingresa");
      return;
    } else {
      next();
    }
  }
});

export default router;
